/**
 * 预览产物文件树工具（Wave 4 R3 / T4.7）。
 *
 * 后端 /debugpavilion/preview/{id}/files 返回平铺的 {path, type, size} 条目，
 * 这里转换成可递归渲染的目录树（目录在前，文件按名排序）。
 */
import type { PreviewFileEntry } from "@/services/debugpavilion";

export interface FileTreeNode {
  name: string;
  path: string;
  type: "dir" | "file";
  size?: number;
  children: FileTreeNode[];
}

/** 平铺的 {path, type} 列表 → 目录树（目录在前，文件按名排序）。 */
export function buildFileTree(entries: PreviewFileEntry[]): FileTreeNode[] {
  const root: FileTreeNode[] = [];
  for (const entry of entries) {
    const segments = entry.path.split("/").filter(Boolean);
    let level = root;
    let acc = "";
    segments.forEach((seg, index) => {
      acc = acc ? `${acc}/${seg}` : seg;
      const isLast = index === segments.length - 1;
      let node = level.find((n) => n.path === acc);
      if (!node) {
        node = {
          name: seg,
          path: acc,
          type: isLast ? entry.type : "dir",
          size: isLast ? entry.size : undefined,
          children: [],
        };
        level.push(node);
      }
      level = node.children;
    });
  }
  const sortNodes = (nodes: FileTreeNode[]): FileTreeNode[] => {
    nodes.sort((a, b) => {
      if (a.type !== b.type) return a.type === "dir" ? -1 : 1;
      return a.name.localeCompare(b.name);
    });
    nodes.forEach((n) => sortNodes(n.children));
    return nodes;
  };
  return sortNodes(root);
}
